import React, { useContext, useEffect } from 'react'
import { API_BASE_URL } from '../lib/constants'
import axios from 'axios'
import { MainContext } from '../contexts/MainContext'
import DentalSurgical from '../components/DentalSurgicalInstruments/DentalSurgical'

const Dentalsurgicalinstruments = ({ page_data }: any) => {
	const { setIsLoading } = useContext(MainContext)
	useEffect(() => {
		setIsLoading(false)
	}, [])

	return <DentalSurgical page_data={page_data} />
}

export const getServerSideProps = async () => {
	const res = await axios.post(`${API_BASE_URL}dental-surgical-instruments`).then((response) => {
		return response?.data
	})
	return {
		props: {
			page_data: res
		}
	}
}

export default Dentalsurgicalinstruments
